import { render, staticRenderFns } from "./CmgAddFavoriteOrderModal.vue?vue&type=template&id=03cbb730&scoped=true&lang=pug"
import script from "./cmg-add-favorite-order-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-add-favorite-order-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgAddFavoriteOrderModal.vue?vue&type=style&index=0&id=03cbb730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cbb730",
  null
  
)

export default component.exports